import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--glass-border)',
      margin: '0',
      padding: '32px 16px 24px',
      background: 'var(--glass-bg)',
      backdropFilter: 'blur(32px) saturate(180%)',
      WebkitBackdropFilter: 'blur(32px) saturate(180%)',
      position: 'relative',
    }}>
      {/* Liquid Glass shimmer */}
      <div style={{
        position: 'absolute', left: 0, right: 0, top: 0, height: 1, pointerEvents: 'none',
        background: 'linear-gradient(90deg, transparent, rgba(200,160,255,0.25), transparent)',
      }} />
      <div style={{ maxWidth: 960, margin: '0 auto' }}>
        {/* Business info */}
        <div style={{ textAlign: 'center', fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)', lineHeight: 2 }}>
          <p style={{ fontFamily: 'var(--p2-display, var(--font-serif))', fontSize: 20, fontWeight: 700, fontStyle: 'italic', color: 'var(--text-primary)', marginBottom: 10 }}>
            청명당<em style={{ fontStyle: 'normal', color: 'var(--p2-pink, var(--accent))' }}>·</em>淸明堂
          </p>
          <p>회사명: 주식회사 모비딕컴퍼니 | 사업자등록번호: 348-88-01535</p>
          <p>통신판매업 신고번호: 제 2023-경기안양-2563호 | 대표자: 강희성</p>
          <p>대표번호: 0507-1355-4769</p>
          <p>&copy; 2025 청명당. AI 기반 운세 분석 서비스</p>
          <p style={{ marginTop: 4 }}>본 서비스는 오락 목적으로 제공되며, 실제 운명 예측을 보장하지 않습니다.</p>
          <p style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid var(--separator)' }}>
            <span style={{ fontWeight: 700 }}>B2B 비즈니스 문의</span>
            <span style={{ color: 'var(--text-muted)', margin: '0 6px' }}>|</span>
            <span style={{ color: 'var(--accent)', fontWeight: 500, cursor: 'pointer' }} onClick={() => { const d = atob('bWFzdGVyQHNrdGVjLmty'); window.location.href = ['mai', 'lto:', d].join(''); }}>{atob('bWFzdGVyQHNrdGVjLmty')}</span>
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 12 }}>
            <Link to="/privacy" style={{ color: 'var(--accent)', fontWeight: 500 }}>개인정보보호정책</Link>
            <span style={{ color: 'var(--text-muted)' }}>|</span>
            <Link to="/terms" style={{ color: 'var(--accent)', fontWeight: 500 }}>이용약관</Link>
            <span style={{ color: 'var(--text-muted)' }}>|</span>
            <Link to="/refund-policy" style={{ color: 'var(--accent)', fontWeight: 500 }}>환불정책</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
